import { render, staticRenderFns } from "./EmployeeMovementAdd.vue?vue&type=template&id=c93dc25a&scoped=true&"
import script from "./EmployeeMovementAdd.vue?vue&type=script&lang=js&"
export * from "./EmployeeMovementAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93dc25a",
  null
  
)

export default component.exports